module.exports = __webpack_public_path__ + "static/media/slide-modal-round.b68642bc.webp";